import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Cropper from 'react-cropper'
import _ from 'lodash'

import Text from 'components/common/Text'
import { uploadToStorage } from 'controllers/storage'
import 'cropperjs/dist/cropper.css'

const Container = styled.div`
  display: flex;
  _height: 32em;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  position: relative;
  margin-bottom: 1em;
`
const LoadingOverlay = styled.div`
  position:absolute;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`


class ShopifyCrop extends Component {

  constructor (props) {
    super(props)
    this.state = {
      loading: true
    }

    this.url = props.file
    if (props.previewEltId) {
      this.preview = document.getElementById(props.previewEltId)
      if (this.preview) {
        this.preview.style.display = 'block'
      }
    }
  }

  componentWillUnmount () {
    console.log('component')
    if (this.preview) {
      this.preview.style.display = 'none'
      while (this.preview.firstChild) {
        this.preview.removeChild(this.preview.firstChild)
      }
    }
  }

  onCropperMounted = (ref) => {
    this.cropper = ref
  }

  renderSpinner () {
    if (this.state.loading) {
      return (
        <LoadingOverlay>
          <Text>Loading...</Text>
        </LoadingOverlay>
      )
    }
  }

  processPreview = () => {
    if (this.preview) {
      const imageData = this.cropper.getImageData()
      const data = this.cropper.getData()
      //console.log('data', data)
      //console.log('imageData', imageData)
      const ratioY = imageData.naturalHeight / data.height
      const ratioX = imageData.naturalWidth / data.width
      const top = data.y / imageData.naturalHeight * (-100)
      const left = data.x / imageData.naturalWidth * (-100)
      const img = document.createElement('img')
      img.style.cssText = (
         `
           position: absolute;
           top: ${top * ratioY}%;
           left: ${left * ratioX}%;
           display:block;
           width:${ratioX * 100}%;
           height:${ratioY * 100}%;
           min-width:0!important;
           min-height:0!important;
           max-width:none!important;
           max-height:none!important;
           image-orientation:0deg!important;
        `
      )
      img.src = this.url
      while (this.preview.firstChild) {
        this.preview.removeChild(this.preview.firstChild)
      }
      this.preview.appendChild(img)
    }
  }

  render () {
    return (
      <Container id='cropper'>
        {/* <ImageContainer> */}
        <Cropper
          style={{ height: '100%', width: '46em', zIndex: 1000 }}
          aspectRatio={9 / 16}
          guides
          src={this.url}
          ref={this.onCropperMounted}
          zoomable={false}
          ready={this.ready}
          viewMode={1}
          autoCropArea={1}
          //preview='.cropper_image_preview'
          //cropstart={() => console.log('crop start')}
          cropmove={this.processPreview}
          //cropend={() => console.log('crop end')}
        />
        {this.renderSpinner()}
      </Container>
    )
  }

  ready = () => {
    this.setState({loading: false})
    this.processPreview()
  }

  srcToFile (src, fileName, mimeType) {
    return (fetch(src)
      .then(res => res.arrayBuffer())
      .then(buf => new File([buf], fileName, {type: mimeType}))
    )
  }

  apply = () => {
    const { file, path, assets, appId, shopifyAppData, dispatch, onCropResizeDone } = this.props
    let assetInfo = _.find(assets, a => a.url === file)
    if (!assetInfo) assetInfo = _.find(shopifyAppData.assets, a => a.url === file)
    const canvas = this.cropper.getCroppedCanvas()
    if (canvas) {
      const src = canvas.toDataURL()
      const fileName = _.get(assetInfo, 'name', file.name)
      const fileType = _.get(assetInfo, 'type', file.type)
      this.srcToFile(src, fileName, fileType).then(croppedFile => {
        dispatch(uploadToStorage(appId, croppedFile, null, (assetInfo) => {
          onCropResizeDone(path, assetInfo.url)
        }))
      })
    }
  }
}

ShopifyCrop.propTypes = {
  file: PropTypes.PropTypes.string.isRequired,
  path: PropTypes.array.isRequired,
  assets: PropTypes.object.isRequired,
  appId: PropTypes.string.isRequired,
  shopifyAppData: PropTypes.object.isRequired,
  previewEltId: PropTypes.string,
  onCropResizeDone: PropTypes.func
}

const mapStateToProps = state => ({
  shopifyAppData: state.shopifyAppData
})

export default connect(mapStateToProps, null, null, { withRef: true })(ShopifyCrop)



// WEBPACK FOOTER //
// ./src/components/shopifyApp/shopifyWizard/shopifyUI/ShopifyCrop.js